import TEALIUM from "../../enums/tealium-enums";
import { track } from "../../util/tealium";

const CBR_DETAIL = "cbr_clock";

/**
 * Tracks the CBR Clock page view on load.
 * page_category: action_report, page_detail: list_view_{YYYYMM}, page_section: cbr_clock
 */
export const cbrPageViewTrack = (period: string) => {
  track(TEALIUM.U_TAG_METHOD.VIEW, "", CBR_DETAIL, TEALIUM.CATEGORY.ACTION_REPORT, `list_view_${period}`, "");
};

/**
 * Tracks click on the customize KPI button (filter icon).
 */
export const cbrCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "customize_KPI",
  );
};

/**
 * Tracks cancel action in the KPI selector modal.
 */
export const cbrCancelCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "cancel_customize_KPI",
  );
};

/**
 * Tracks apply action in the KPI selector modal.
 */
export const cbrApplyCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "apply_customize_KPI",
  );
};

/**
 * Tracks sort ascending click (most urgent first).
 */
export const cbrSortAscendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "sort_ascending",
  );
};

/**
 * Tracks sort descending click (least urgent first).
 */
export const cbrSortDescendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "sort_descending",
  );
};

/**
 * Tracks export button click.
 */
export const cbrExportTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "export",
  );
};

/**
 * Tracks ABO profile click.
 */
export const cbrProfileTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "profile",
  );
};

/**
 * Tracks adding an ABO to the watchlist.
 */
export const cbrAddToWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "add_to_watchlist",
  );
};

/**
 * Tracks removing an ABO from the watchlist.
 */
export const cbrRemoveFromWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "remove_from_watchlist",
  );
};

/**
 * Tracks click on the CBR Clock info icon.
 */
export const cbrInfoTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "info",
  );
};

/**
 * Tracks phone icon click.
 */
export const cbrPhoneIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "phone_icon",
  );
};

/**
 * Tracks message icon click.
 */
export const cbrMessageIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    CBR_DETAIL,
    "message_icon",
  );
};
